import React from 'react'
import './footer.scss'
export const Footer = () => {
  return (
    <div className='footer'>@ 2024 xybechill 黄星源 Fronted Programmer</div>
  )
}
